<template>
  <a-spin :spinning="confirmLoading">
    <div class="project-title">
      <div class="project-name">
        <a-icon type="alert" />{{ projectInfo.name }}
      </div>
      <a-dropdown>
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item :key="item.id" v-for="item in projectList">
            <a-icon type="deployment-unit" />
            {{ item.name }}
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 30px"
          >切换学校<a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>
  </a-spin>
</template>

<script>
import { SettingSchool } from "@/api";
import storage from "@/utils/storage";
// import store from "@/store";
import { CHOSE_SCHOOL } from "@/utils/mutation-types";
export default {
  components: {},
  data() {
    return {
      confirmLoading: false,
      projectList: [],
      projectInfo: {
        name: "",
        id: "",
      },
    };
  },
  mounted() {},
  created() {
    this.getProject();
  },
  methods: {
    // 切换项目
    handleMenuClick({ key }) {
      const newPro = this.projectList.find(v => v.id == key);
      this.projectInfo = newPro;
      storage.set(CHOSE_SCHOOL, this.projectInfo, 7 * 24 * 60 * 60 * 1000);
      this.$store.commit("user/setSchoolId", this.projectInfo.id);
      this.$emit("change", this.projectInfo);
    },
    // 获取项目
    getProject() {
      this.confirmLoading = true;
      SettingSchool.schoolFindByPage({
        paging: {
          page: 1,
          limit: 999,
        },
      }).then(res => {
        if (res.code == this.config.pubCode) {
          this.projectList = res.data;
          const chosedPro = storage.get(CHOSE_SCHOOL);
          if (chosedPro) {
            if (res.data.length) {
              const aa = res.data.find(v => v.id == chosedPro.id);
              if (aa) {
                this.projectInfo = aa;
              } else {
                this.projectInfo = res.data[0];
              }
            }
          } else {
            if (res.data.length) {
              this.projectInfo = res.data[0];
            }
          }
          if (res.data.length) {
            storage.set(
              CHOSE_SCHOOL,
              this.projectInfo,
              7 * 24 * 60 * 60 * 1000
            );
            this.$store.commit("user/setSchoolId", this.projectInfo.id);
            this.$emit("change", this.projectInfo);
          }
        }
        this.confirmLoading = false;
      });
    },
  },
};
</script>
<style lang="less">
// 页面头
.project-title {
  border-bottom: 1px solid @border-color;
  padding: 15px 25px;
  display: flex;
  .project-name {
    font-size: 20px;
    font-weight: bold;
    i {
      color: @blue;
      margin-right: 10px;
    }
  }
}
</style>
